import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class ExcelInventoryImport_ds_get_container_typesService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { names?: string[], weights?: number[], categories?: number[] }): 
  Promise<{ result: { Id?: number, ContainerTypeCategories?: number, Name?: string, Weight?: number }[] }> 
  {
    let url = `${environment.backendUrl}api/ExcelInventoryImport/datasources/ds_get_container_types/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { names?: string[], weights?: number[], categories?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ContainerTypeCategories?: number, Name?: string, Weight?: number }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/ExcelInventoryImport/datasources/ds_get_container_types/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { names?: string[], weights?: number[], categories?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, ContainerTypeCategories?: number, Name?: string, Weight?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/ExcelInventoryImport/datasources/ds_get_container_types/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      names?: string[], weights?: number[], categories?: number[]    }) {
      return false;
    }
}
